import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function PromptEngineerLanding({ onStart, onBack }) {
    return (
        <Card elevation={2}>
            <CardContent>
                <Stack spacing={2}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <AutoAwesomeIcon color="primary" />
                        <Typography variant="h6">Meet Your AI Instruction Architect</Typography>
                    </Stack>
                    <Typography variant="body1">
                        Work with the resident AI Instruction Architect.
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        You will answer a short interview so the AI Instruction Architect can engineer production-ready instructions in a future step.
                    </Typography>
                    <Box
                        sx={{
                            border: '1px solid',
                            borderColor: 'divider',
                            borderRadius: 2,
                            p: 2,
                            backgroundColor: '#f8fbff'
                        }}
                    >
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            Users answer business questions. The AI Instruction Architect answers AI questions.
                        </Typography>
                    </Box>
                    <Stack direction="row" spacing={2}>
                        <Button variant="contained" onClick={onStart}>
                            START INTERVIEW
                        </Button>
                        <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={onBack}>
                            Back
                        </Button>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    );
}
